import { FC, FocusEvent } from 'react';
import { useField } from 'formik';
import { IBaseField } from './BaseField';
import { TextArea } from 'src/Controls';

interface ITextFieldProps extends IBaseField {
	rows?: number;
	/** Подстраивать высоту инпута автоматически */
	isAutoHeight?: boolean;
}

/**
 * Текстовое поле
 */
const TextAreaField: FC<ITextFieldProps> = (props) => {
	const { name, ...otherProps } = props;
	const [inputProps, meta, helpers] = useField(name);

	/** Очищает крайние пробелы и проверяет обновлённое значение поля */
	const onBlurHandler = async (event: FocusEvent<HTMLTextAreaElement>) => {
		const trimmedValue = event.target.value.trim();
		if (trimmedValue !== event.target.value) {
			event.target.value = trimmedValue;
			await helpers.setValue(trimmedValue, true);
			await helpers.setTouched(true, false);
			return;
		}

		inputProps.onBlur(event);
	};

	return (
		<TextArea
			{...otherProps}
			{...inputProps}
			{...meta}
			onBlur={onBlurHandler}
		/>
	);
};

export default TextAreaField;
